import React, { useMemo } from 'react';
import { VisualizeEngine } from '@tier4/autowareviz-core';
import { RTCTask } from '../../../../core/models/rtc';
import { RTCLayout } from '../../atoms/RTCLayout';
import { VisualizerView } from '../../molecules/VisualizerView';
import { RTCQueuePanel } from '../../molecules/RTCQueuePanel';

export type RTCPageTemplateProps = {
    engine: VisualizeEngine;
    tasks: RTCTask[];
    files: File[] | undefined;
}

export function RTCPageTemplate(props: RTCPageTemplateProps) {
    const { engine, tasks, files } = props;

    const mapFiles = useMemo(() => (files ?? []).filter(f => f.name.endsWith('.osm')), [files]);

    return engine
        ? <RTCLayout
            viz={<VisualizerView engine={engine} mapFiles={mapFiles} />}
            queue={<RTCQueuePanel tasks={tasks} />} />
        : <></>
        ;
}
